export default __webpack_public_path__ + "static/media/4.2034f315.jpg";